import React, { lazy } from 'react';
import { X } from 'lucide-react';
export function ComparisonSection() {
  return <section className="py-20 bg-white px-4 border-y border-gray-100" data-id="element-17">
      <div className="max-w-4xl mx-auto text-center" data-id="element-18">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-12" data-id="element-19">
          💔 Por qué lo demás no funcionó
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-20">
          {[{
          title: 'Pastillas',
          desc: 'Silencian, pero no enseñan seguridad.',
          image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=280&h=180&fit=crop'
        }, {
          title: 'Terapia',
          desc: 'Explica, pero no regula el cuerpo en el momento.',
          image: 'https://images.unsplash.com/photo-1573497620053-ea5300f94f21?w=280&h=180&fit=crop'
        }, {
          title: 'Meditación larga',
          desc: 'Funciona… solo si ya estás tranquila.',
          image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=280&h=180&fit=crop'
        }, {
          title: 'Frases positivas',
          desc: 'No alcanzan al sistema nervioso.',
          image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=280&h=180&fit=crop'
        }, {
          title: 'Distracciones',
          desc: 'Evitan, pero no contienen.',
          image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=280&h=180&fit=crop'
        }].map((item, i) => <div key={i} className="rounded-xl bg-gray-50 border border-gray-100 overflow-hidden hover:shadow-md transition-shadow" data-id="element-21">
              <div className="relative h-36 w-full overflow-hidden" data-id="element-22">
                <img src={item.image} alt={item.title} className="h-full w-full object-cover grayscale opacity-70" loading="lazy" data-id="element-23" />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-50 to-transparent" data-id="element-24"></div>
                <div className="absolute top-3 right-3 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center shadow-sm" data-id="element-25">
                  <X className="h-5 w-5 text-red-500" data-id="element-26" />
                </div>
              </div>
              <div className="p-5" data-id="element-27">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-28">{item.title}</h3>
                <p className="text-sm text-gray-600" data-id="element-29">{item.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="relative inline-block px-10 py-8 rounded-2xl bg-gradient-to-r from-[#C4973B] via-[#D4A84C] to-[#C4973B] shadow-xl overflow-hidden" data-id="element-30">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-pulse" data-id="element-31"></div>
          <p className="relative z-10 text-xl font-serif text-white" data-id="element-32">
            👉 Tu cuerpo no necesita control. <br data-id="element-33" />
            <span className="font-bold text-2xl block mt-2" data-id="element-34">
              👉 Necesita contención.
            </span>
          </p>
        </div>
      </div>
    </section>;
}